import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
let currentLang = JSON.parse(document.getElementById('langSite').innerHTML).lang
const lang = currentLang == 'fr' ? '/' : `/${currentLang}/`
const baseUrl = `${lang}wp-json/wp/v2`

if (document.getElementById('vue-faqs')) {
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const faqs = await $http.$get(`${baseUrl}/faqs`)
      return { faqs }
    },
    el: '#vue-faqs',
    filters: {
      format(date) {
        return moment(date).locale('fr').format('DD.MM.YYYY')
      }
    },
    data() {
      return {
        isLoading: true,
        categories: [],
        filters: {
          page: 1,
          per_page: 100,
        },
        faqs: [],
        totalPages: null
      }
    },
    computed: {
      hasMore() {
        return this.totalPages > this.faqs.length;
      }
    },
    mounted() {
      this.getCategories()
      this.getFaqs()
    },
    methods: {
      getCategories() {
        axios.request({
          method: 'GET',
          url: `${baseUrl}/categories_faq`,
          params: {
            per_page: 100,
          }
        }).then(response => {
          this.categories = response.data
          this.deleteEmptyCategories()
        })
      },
      deleteEmptyCategories() {
        this.categories = this.categories.filter((el) => el.count != 0)
      },
      getFaqs(more = false) {
        this.isLoading = true
        axios.request({
          method: 'GET',
          url: `${baseUrl}/faqs`,
          data: this.form,
          headers: { 'content-type': 'application/json' },
          params: this.filters
        }).then(response => {
          this.faqs = (more)? this.faqs.concat(response.data) : response.data
          this.totalPages = response.headers['x-wp-total']
          this.isLoading = false
        }).catch((error) => {
          this.errors = Object.assign(this.errors, error.response.data)
        })
      },
      // getMore() {
      //   this.filters.page++;
      //   this.getFaqs(true)
      // },
      getCategory(category_id) {
        let category = this.categories.filter((obj) => obj.id === category_id)
        let categoryName = (category.length > 0)? category[0]['name'] : ''
        return categoryName
      },
      getOrigin(origin_id) {
        let origin = this.origins.filter((obj) => obj.id === origin_id)
        let originName = (origin.length > 0)? origin[0]['name'] : ''
        return originName
      },

      updateCategory(category) {
        this.faqs = []
        this.filters.categories_faq = category
        this.getFaqs()
      },
      
    }
  })
}
